export default "__VITE_ASSET__DHRMbyk4__"